import { useState } from "react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { Share2, Copy, Check, MessageCircle, Facebook, Twitter } from "lucide-react";

export const ShareButton = ({ path, title, testId }) => {
  const [copied, setCopied] = useState(false);
  const url = `${window.location.origin}${path}`;
  const text = title ? `${title}\n${url}` : url;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Link berhasil disalin", { description: url });
    setTimeout(() => setCopied(false), 2000);
  };

  const openShare = (shareUrl) => window.open(shareUrl, "_blank", "noopener,width=640,height=540");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" title="Bagikan link" data-testid={testId}>
          <Share2 size={15} className="text-sky-600" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel className="font-heading text-xs">Bagikan Tautan</DropdownMenuLabel>
        <p className="px-2 pb-1.5 font-mono text-[10px] text-slate-400 break-all leading-snug">{url}</p>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={copy} data-testid={`${testId}-copy`}>
          {copied ? <Check size={15} className="mr-2 text-emerald-600" /> : <Copy size={15} className="mr-2 text-slate-500" />}
          Salin Link
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => openShare(`https://wa.me/?text=${encodeURIComponent(text)}`)} data-testid={`${testId}-wa`}>
          <MessageCircle size={15} className="mr-2 text-emerald-600" /> Bagikan ke WhatsApp
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => openShare(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`)} data-testid={`${testId}-fb`}>
          <Facebook size={15} className="mr-2 text-blue-600" /> Bagikan ke Facebook
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => openShare(`https://twitter.com/intent/tweet?text=${encodeURIComponent(title || "")}&url=${encodeURIComponent(url)}`)} data-testid={`${testId}-tw`}>
          <Twitter size={15} className="mr-2 text-sky-500" /> Bagikan ke X / Twitter
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
